var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEdit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 28C21.732 28 28 21.732 28 14C28 6.26801 21.732 0 14 0C6.26801 0 0 6.26801 0 14C0 21.732 6.26801 28 14 28ZM11.7347 19.5529L18.6751 12.6111L15.3874 9.3233L8.4482 16.2651C8.07558 16.6376 7.81125 17.1044 7.68351 17.6155L7.01761 20.2769C6.99305 20.3744 6.9942 20.4766 7.02094 20.5735C7.04769 20.6704 7.09911 20.7587 7.17019 20.8298C7.24127 20.9009 7.32957 20.9523 7.42647 20.9791C7.52337 21.0058 7.62555 21.007 7.72303 20.9824L10.3855 20.3165C10.8961 20.1889 11.3624 19.9249 11.7347 19.5529ZM21 9.32446C21 8.70812 20.7552 8.11701 20.3195 7.68113C20.1036 7.46519 19.8474 7.29389 19.5653 7.17702C19.2833 7.06015 18.9809 7 18.6756 7C18.3703 7 18.068 7.06015 17.7859 7.17702C17.5039 7.29389 17.2476 7.46519 17.0318 7.68113L16.209 8.50163L19.4967 11.7883L20.3195 10.9678C20.7552 10.5319 21 9.94081 21 9.32446Z",
    fill: "#078950"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.f74fc9f2.svg";
export { ForwardRef as ReactComponent };